import React, { useState } from "react";
import { Card, Button, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { multiFactor } from "firebase/auth";
import { useAuth } from "../../../firebase/AuthProvider";
import { showConfirmationDialog } from "../../modal/ConfimationModal/Confimation"; // <-- added

const MultiFactorDisableAuthCard = () => {
  const { currentUser } = useAuth();
  const [busy, setBusy] = useState(false);

  const handleDisable = async () => {
    if (!currentUser) {
      toast.error("User not authenticated.");
      return;
    }
    setBusy(true);
    try {
      const mfUser = multiFactor(currentUser);
      const enrolled = (mfUser as any).enrolledFactors || [];
      if (enrolled.length === 0) {
        toast.info("No multi-factor enrollments found.");
        return;
      }
      const factor = enrolled.find((f: any) => f.factorId?.includes("totp")) || enrolled[0];
      await mfUser.unenroll(factor);
      toast.success("Multi-factor authentication disabled.");
    } catch (err: any) {
      console.error("Failed to disable MFA:", err);
      if (err?.code === "auth/requires-recent-login") {
        toast.error("Please re-authenticate to disable MFA (sign in again).");
      } else {
        toast.error(err?.message ?? "Failed to disable MFA.");
      }
    } finally {
      setBusy(false);
    }
  };

  const confirmAndDisable = async () => {
    const confirmed = await showConfirmationDialog(
      "Disable 2FA",
      "Are you sure you want to disable multi-factor authentication?",
      "Yes, disable",
      "Cancel",
      "warning"
    );
    if (!confirmed) return;
    await handleDisable();
  };

  return (
    <Card className="mt_mfa-card">
      <Card.Body>
        <Card.Title className="mt_mfa-title">Multi-factor Authentication</Card.Title>

        <Alert variant="success" className="mt_mfa-alert d-flex align-items-center">
          <span>Two-factor authentication is currently enabled on your account.</span>
        </Alert>

        <div className="mt_mfa-footer">
          <Button
            variant="outline-danger"
            className="mt_mfa-disable-btn"
            onClick={confirmAndDisable}
            disabled={busy}
          >
            {busy ? "Disabling..." : "Disable 2FA"}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MultiFactorDisableAuthCard;
